import { useAuth0 } from '@auth0/auth0-react';

export default function LoginPage() {
  const { loginWithRedirect, isLoading } = useAuth0();

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 px-10 py-12 max-w-md w-full text-center">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900">Website Builder Audit Platform</h1>
          <p className="text-gray-500 mt-2 text-sm">
            AI-powered WCAG checking and WordPress block analytics
          </p>
        </div>

        <button
          onClick={() => void loginWithRedirect()}
          disabled={isLoading}
          className="w-full bg-brand-600 hover:bg-brand-700 disabled:opacity-60 text-white font-semibold py-3 px-6 rounded-lg transition-colors"
        >
          {isLoading ? 'Loading…' : 'Sign in with Auth0'}
        </button>
      </div>
    </div>
  );
}
